import type {
    ApplicationWorkbookTemplateListItem,
    OrgApplicationWorkbookListItem,
    PropertyApplicationWorkbookListItem,
} from './workbook.types'
import {
    formatPropertyWorkbookProvenance,
    formatWorkbookTemplateProvenance,
} from './workbookConfigProvenance'
import { adoptionStatusLabel } from './workbookStatus'

export function formatWorkbookStatusOrProvenance(
    workbook: PropertyApplicationWorkbookListItem,
    options?: {
        templatesByKey?: Map<string, ApplicationWorkbookTemplateListItem>
        orgWorkbooksById?: Map<number, OrgApplicationWorkbookListItem>
    },
): string {
    const legacyStatuses: PropertyApplicationWorkbookListItem['adoption_status'][] = [
        'synced',
        'forked',
        'stale',
    ]

    if (legacyStatuses.includes(workbook.adoption_status)) {
        return adoptionStatusLabel(workbook.adoption_status)
    }

    const provenance = formatPropertyWorkbookProvenance(workbook, options)
    if (provenance) {
        return provenance
    }

    return adoptionStatusLabel(workbook.adoption_status)
}

export function formatOrgWorkbookProvenance(
    workbook: OrgApplicationWorkbookListItem,
    templatesByKey?: Map<string, ApplicationWorkbookTemplateListItem>,
): string | null {
    return formatWorkbookTemplateProvenance(workbook, templatesByKey)
}
